import Api from "./Api";
import store from "../state/store";
import axios from "axios";

export default {
  getUserTypesWithChildren(params) {
    return Api().get(
      `/user-types/${store.getters["authfack/currentEntity"].id}`, { params }
    );
  },
  getTypesParent(params) {
    if (params)
      return Api().get(
        `/user_type_parent/${store.getters["authfack/currentEntity"].id}/${params.parent_id}`
      );
    return Api().get(
      `/user_type_parent/${store.getters["authfack/currentEntity"].id}`
    );
  },
  getUserTypesDuplication(params) {
    return Api().get('/usertypes/unique', { params });
  },
  getAllUsersTypes() {
    return Api().get(
      `/user-types/list/${store.getters["authfack/currentEntity"].id}`
    );
  },
  getAllPreRegistrationByAdminUserTypes(params) {
    return Api().get(`/user_types_by_pre_registation_method/${store.getters["authfack/currentEntity"].id}`, { params });
  },
  getAllPreRegistrationByAdminUserTypesAndPermittedNormalAreas(params) {
    return Api().get(`/user-types/pre-registered-and-permitted-sites/${store.getters["authfack/currentEntity"].id}`, { params });
  },
  getAllParentsUsersTypes() {
    return Api().get(`/user_type_parent_with_children/${store.getters["authfack/currentEntity"].id}`);
  },
  createUserType(params) {
    return Api().post("/user-type", params);
  },
  updateUserType(params) {
    return Api().put(`/user-type/update/${params.id}`, params.form);
  },
  moveUserType(params) {
    return Api().put(`/user-types/move`, params);
  },
  deleteUserType(id) {
    return Api().delete(`/user-types/${id}`);
  },
  getUserType(id) {
    return Api().get(`/user-type/${id}`);
  },

  getRegistrationTypes(id) {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
    return axios.get(
      `${process.env.VUE_APP_BASE_URL}/api/get_pre_registration_user_type/${id}`,
      {
        headers: headers,
      }
    );
  },
  getCheckChangeRegMethod(id) {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
    return axios.get(
      `${process.env.VUE_APP_BASE_URL}/api/check-change-userType-registration-method/${id}`,
      {
        headers: headers,
      }
    );
  },

  getCheckChangeRegAllowed(id) {
    return Api().get(`/check-change-userType-registration-allowed/${id}`);
  },

  getHostSettings(params) {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
    return axios.get(
      `${process.env.VUE_APP_BASE_URL}/api/hosts/settings/${params.journey_id}/${params.user_type_id}`,
      {
        headers: headers,
      }
    );
  },

  getHostOptions(params) {
    return axios.post(
      `${process.env.VUE_APP_BASE_URL}/api/hosts/search`,
      params
    ).then(response => {
      return Promise.resolve(response)
    })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },

  getAvailableHosts(params) {
    return Api().get(`/search_For_The_User_In_The_Flow_Host`, {
      params
    });

  },
  getUserTypesBySitesIds(params) {
    return Api().get(`/user-types/sites/flows`, params);
  },
  userTypeMassAction(params) {
    return Api().put("/users_usertype", { data: params });
  },
  getPermittedUserTypes() {
    return Api().get(`/user_types_by_entity/${store.getters["authfack/currentEntity"].id}`)
  },
  getPermittedUserTypeWithJourneyId(journeyId, areaId){
    return Api().get(`/user-type-journey/${journeyId}/${areaId}`)
  },
  getUserTypesWithHierarchy() {
    return Api().get(`/user_types/${store.getters["authfack/currentEntity"].id}`)
  },
};
